






































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"ConditionsGeneralesVente",
  components: {    
  },
})
export default class ConditionsGeneralesVente extends Vue {}
